module.exports = {
	"urls": {
		"API_URL": "https://api.server-eye.de",
		"API_URL_BETA": "https://beta-api.server-eye.de",
		"PM_API_URL": "https://pm.server-eye.de",
		"PM_API_URL_BETA": "https://beta-pm.server-eye.de",
		"PATCH_API_URL": "https://patch.server-eye.de",
		"STATIC_SE_URL": "https://static.server-eye.de"
	}
};


//////////////////
// WEBPACK FOOTER
// ./config/config.json
// module id = 745
// module chunks = 0 1